// extracted by mini-css-extract-plugin
export default {"overlayImagesContainer":"lR-z","loadingMedia":"mR-z","reviewsImagesAndVideos":"nR-z","limitHeight":"oR-z"};